import * as yup from "yup";

export const CategorySchema = yup.object().shape({
  categoryName: yup.string().required("Category name is required")
  .matches(/^[^\s]+(\s+[^\s]+)*/, "Characters must be alphanumaric")
    .max(30, "Max  length 30 characters"),
});
